import React, { useState } from 'react';

const RangeFilter = ({ label = "", onChange = null, defaultValue = [0, 100] }) => {
    const [minValue, setMinValue] = useState(parseInt(defaultValue[0]));
    const [maxValue, setMaxValue] = useState(parseInt(defaultValue[1]));

    const handleMinValueChange = (e) => {
        const newMinValue = Number(e.target.value);
        setMinValue(newMinValue);
        onChange([newMinValue, maxValue]);
    };

    const handleMaxValueChange = (e) => {
        const newMaxValue = Number(e.target.value);
        setMaxValue(newMaxValue);
        onChange([minValue, newMaxValue]);
    };

    return (
        <div>
            <label htmlFor="slider">
                { label }
            </label>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                padding: "8px",
                outline: "1px solid var(--clr-accent)",
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                }}>
                    <input
                        type="range"
                        id="slider"
                        min="0"
                        max="100"
                        step="10"
                        value={minValue ?? 0}
                        onChange={handleMinValueChange}
                    />
                    <div>{minValue ?? "0"}%</div>
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                }}>
                    <input
                        type="range"
                        id="slider2"
                        min="0"
                        max="100"
                        step="10"
                        value={maxValue ?? 100}
                        onChange={handleMaxValueChange}
                    />
                    <div>{maxValue ?? "100"}%</div>
                </div>
            </div>
        </div>
    );
};

export default RangeFilter;
